exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loged-block {\n  top: 50%;\n  margin-top: -200px;\n  left: 50%;\n  margin-left: -200px;\n  position: absolute;\n  width: 400px;\n  height: 400px; }\n\n.input-wrapper {\n  width: 100%; }\n\nform {\n  width: 100%; }\n\nlabel {\n  font-size: 0.9em; }\n\n.form-group {\n  position: relative; }\n  .form-group button {\n    width: 100%; }\n\n.alert {\n  left: 330px;\n  position: absolute;\n  font-size: 0.7em;\n  transition: all linear 0.8s !important;\n  white-space: nowrap;\n  top: 30px; }\n\n.has-danger .form-control-danger {\n  background-image: none; }\n\n#message-error-login {\n  width: 100%;\n  position: relative;\n  left: auto;\n  top: auto;\n  font-size: 0.9em; }\n\n.btn-primary {\n  cursor: pointer; }\n\n.logo-wrapper {\n  width: 100%;\n  text-align: center;\n  margin-bottom: 30px; }\n  .logo-wrapper img {\n    width: 70%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/pages/login/login.styles.scss
// module id = ../../../../../src/app/pages/login/login.styles.scss
// module chunks = main